<div class="variant-selection-container">
  <div class="content">
    <div class="variant">
      <div class="name"> {{ variant.name }} </div>
      <div class="selection" *ngIf="variant.variants?.length <= 3; else dropDown">
        <kion-variant-selection-item
          *ngFor="let item of variant.variants"
          [variant]="item"
          (select)="selectVariant($event)"
        ></kion-variant-selection-item>
      </div>
      <ng-template #dropDown>
        <div class="selection">
          <kion-drop-down
            [options]="options"
            [showDropDownOnClick]="true"
            [showSelectedOption]="true"
            selectedOptionPosition="before"
            (selected)="selectVariantFromDropDown($event)"
          ></kion-drop-down>
        </div>
      </ng-template>
    </div>
  </div>
</div>
